<template>
  <div id="modal" class="modal order_search_modal" v-show="modalShown">
    <div class="modal-main modal-container" id="order_search_modal">
      <div class="modal-header">絞り込み検索</div>
      <div>
        <div class="search_content2">
          <div class="search_th">注文情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">注文番号</div>
              <input type="text" class="search_td" v-model="searchForm.orderCode" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">注文個別番号</div>
              <input type="text" class="search_td" v-model="searchForm.odMgCode" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">プランID</div>
              <input type="text" class="search_td" v-model="searchForm.planId" maxlength="64"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">ステータス</div>
              <div class="search_td container flex-wrap">
                <div v-for="(status,index) in statusList" :key="'st-' + index">
                  <!-- <input type="checkbox" :id="'pro_' + index" @click="setStatus($event, status.id)" :value="existStatus(status.id)"> -->
                  <input type="checkbox" :id="'pro_' + index" @click="setStatus($event, status.id)"
                    v-model="searchForm.status" v-bind:value="status.id"/>
                  <!-- <input type="checkbox" :id="'pro_' + index" @click="setStatus($event, status.id)"> -->
                  <label :for="'pro_' + index">{{status.label}}</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">更新者名</div>
              <input type="text" class="search_td" v-model="searchForm.updateUserName" maxlength="64"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">受注日時</div>
              <div class="search_td">
                <dd-calendar
                  ref="orderDateStartRef"
                  :value="formatDate(searchForm.orderDateStart)"
                  :clearBtn="true"
                  :name="'orderDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="orderDateEndRef"
                  :value="formatDate(searchForm.orderDateEnd)"
                  :clearBtn="true"
                  :name="'orderDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">決済方法</div>
              <div class="search_td container flex-wrap">
                <div v-for="(payment,index) in paymentList" :key="'st-' + index">
                  <input type="checkbox" :id="'payment_' + index" @click="setPaymentType($event, payment.id)"
                    v-model="searchForm.paymentType" v-bind:value="payment.id"/>
                  <label :for="'payment_' + index">{{payment.label}}</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">支払い期日</div>
              <div class="search_td  container flex-column left">
                <div class="flex">
                  <div :class="{flex: true}">
                    <dd-calendar
                      ref="paymentDateLimitStartRef"
                      :value="formatDate(searchForm.paymentDateLimitStart)"
                      :clearBtn="true"
                      :name="'paymentDateLimitStart'"
                      @selectedDate="selectedDate"
                      @clearedDate="clearedDate"
                    />
                    <div class="separator">～</div>
                    <dd-calendar
                      ref="paymentDateLimitEndRef"
                      :value="formatDate(searchForm.paymentDateLimitEnd)"
                      :clearBtn="true"
                      :name="'paymentDateLimitEnd'"
                      @selectedDate="selectedDate"
                      @clearedDate="clearedDate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">支払い確認日</div>
              <div class="search_td  container flex-column left">
                <div class="flex">
                  <input type="radio" name="radio" id="shiharai_01" :value="1" v-model.number="searchForm.paymentDateType" @click="onClickPaymentDate($event)">
                  <label for="shiharai_01" class="check_only"></label>
                  <div :class="{flex: true, disabled: !isSelectedPaymentDate}">
                    <dd-calendar
                      ref="paymentDateStartRef"
                      :value="formatDate(searchForm.paymentDateStart)"
                      :clearBtn="true"
                      :name="'paymentDateStart'"
                      @selectedDate="selectedDate"
                      @clearedDate="clearedDate"
                    />
                    <div class="separator">～</div>
                    <dd-calendar
                      ref="paymentDateEndRef"
                      :value="formatDate(searchForm.paymentDateEnd)"
                      :clearBtn="true"
                      :name="'paymentDateEnd'"
                      @selectedDate="selectedDate"
                      @clearedDate="clearedDate"
                    />
                  </div>
                </div>
                <div>
                  <input type="radio" name="radio" id="shiharai_02" :value="2" v-model.number="searchForm.paymentDateType" @click="onClickPaymentDate($event)">
                  <label for="shiharai_02">未決済</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">ご請求金額（税抜）</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.priceStart" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.priceEnd" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">ご請求金額（税込）</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.priceTaxStart" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.priceTaxEnd" maxlength="32"/>
              </div>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">商品情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">シリーズ名</div>
              <input type="text" class="search_td" v-model="searchForm.seriesName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">商品名</div>
              <input type="text" class="search_td" v-model="searchForm.productName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">Wサイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeWStart" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeWEnd" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">Hサイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeHStart" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeHEnd" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">Dサイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeDStart" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeDEnd" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">W2サイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeW2Start" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeW2End" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">H2サイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeH2Start" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeH2End" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">D2サイズ</div>
              <div class="search_td  container flex-row left">
                <input type="text" v-model.number="searchForm.sizeD2Start" maxlength="32"/>
                <div class="separator">～</div>
                <input type="text" v-model.number="searchForm.sizeD2End" maxlength="32"/>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">扉カラー</div>
              <input type="text" class="search_td" v-model="searchForm.doorColor" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">キャビネットカラー/棚/脚カラー</div>
              <input type="text" class="search_td" v-model="searchForm.cabineColor" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">カウンターカラー</div>
              <input type="text" class="search_td" v-model="searchForm.counterColor" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">組立設置</div>
              <div class="search_td container flex-wrap">
                <div>
                  <input type="radio" name="const" id="const_01" v-model="searchForm.isConstruct" value="true" @click="onClickRadioButton($event, 'isConstruct')">
                  <label for="const_01">あり</label>
                </div>
                <div>
                  <input type="radio" name="const" id="const_02" v-model="searchForm.isConstruct" value="false" @click="onClickRadioButton($event, 'isConstruct')">
                  <label for="const_02">なし</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">受け取り搬入サービス</div>
              <div class="search_td container flex-wrap">
                <div>
                  <input type="radio" name="carry" id="carry_01" v-model="searchForm.isCarry" value="true" @click="onClickRadioButton($event, 'isCarry')">
                  <label for="carry_01">あり</label>
                </div>
                <div>
                  <input type="radio" name="carry" id="carry_02" v-model="searchForm.isCarry" value="false" @click="onClickRadioButton($event, 'isCarry')">
                  <label for="carry_02">なし</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">出品メーカー</div>
              <input type="text" class="search_td" v-model="searchForm.makerName" maxlength="32"/>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">納品先情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">施主名（物件名）</div>
              <input type="text" class="search_td" v-model="searchForm.businessName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">納品先名</div>
              <input type="text" class="search_td" v-model="searchForm.deliveryName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">受取人氏名</div>
              <input type="text" class="search_td" v-model="searchForm.receiverName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">受取人電話番号</div>
              <input type="text" class="search_td" v-model="searchForm.receiverTel" maxlength="11"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">納品先住所</div>
              <input type="text" class="search_td" v-model="searchForm.deliveryAddress" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">希望納品日</div>
              <div class="search_td">
                <dd-calendar
                  ref="infoDeliveryDateStartRef"
                  :value="formatDate(searchForm.infoDeliveryDateStart)"
                  :clearBtn="true"
                  :name="'infoDeliveryDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="infoDeliveryDateEndRef"
                  :value="formatDate(searchForm.infoDeliveryDateEnd)"
                  :clearBtn="true"
                  :name="'infoDeliveryDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">確定納品日</div>
              <div class="search_td">
                <dd-calendar
                  ref="deliveryDateStartRef"
                  :value="formatDate(searchForm.deliveryDateStart)"
                  :clearBtn="true"
                  :name="'deliveryDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="deliveryDateEndRef"
                  :value="formatDate(searchForm.deliveryDateEnd)"
                  :clearBtn="true"
                  :name="'deliveryDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">配送情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">PF納品日</div>
              <div class="search_td">
                <dd-calendar
                  ref="platformDateStartRef"
                  :value="formatDate(searchForm.platformDateStart)"
                  :clearBtn="true"
                  :name="'platformDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="platformDateEndRef"
                  :value="formatDate(searchForm.platformDateEnd)"
                  :clearBtn="true"
                  :name="'platformDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">お客様納品日</div>
              <div class="search_td">
                <dd-calendar
                  ref="userDateStartRef"
                  :value="formatDate(searchForm.userDateStart)"
                  :clearBtn="true"
                  :name="'userDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="userDateEndRef"
                  :value="formatDate(searchForm.userDateEnd)"
                  :clearBtn="true"
                  :name="'userDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">商品個口数</div>
              <input type="text" class="search_td" v-model.number="searchForm.productUnitCount" maxlength="4"/>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">組立設置情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">立会人氏名</div>
              <input type="text" class="search_td" v-model="searchForm.attendName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">立会人電話番号</div>
              <input type="text" class="search_td" v-model="searchForm.attendTel" maxlength="11"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">組立設置先</div>
              <input type="text" class="search_td" v-model="searchForm.constructAddress" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">確定組立設置日</div>
              <div class="search_td">
                <dd-calendar
                  ref="constructDateStartRef"
                  :value="formatDate(searchForm.constructDateStart)"
                  :clearBtn="true"
                  :name="'constructDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="constructDateEndRef"
                  :value="formatDate(searchForm.constructDateEnd)"
                  :clearBtn="true"
                  :name="'constructDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">ご自宅のタイプ</div>
              <div class="search_td container flex-wrap">
                <div>
                  <input type="radio" name="hometype" id="hometype_01" v-model="searchForm.isHomeType" value="1" @click="onClickRadioButton($event, 'isHomeType')">
                  <label for="hometype_01">戸建</label>
                </div>
                <div>
                  <input type="radio" name="hometype" id="hometype_02" v-model="searchForm.isHomeType" value="2" @click="onClickRadioButton($event, 'isHomeType')">
                  <label for="hometype_02">マンション・アパート</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">駐車スペースの有無</div>
              <div class="search_td container flex-wrap">
                <div>
                  <input type="radio" name="park" id="park_01" v-model="searchForm.isParking" :value="true" @click="onClickRadioButton($event, 'isParking')">
                  <label for="park_01">あり</label>
                </div>
                <div>
                  <input type="radio" name="park" id="park_02" v-model="searchForm.isParking" :value="false" @click="onClickRadioButton($event, 'isParking')">
                  <label for="park_02">なし</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">注文者情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">発注者名</div>
              <input type="text" class="search_td" v-model="searchForm.userName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">会社名</div>
              <input type="text" class="search_td" v-model="searchForm.corpName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">所属部署</div>
              <input type="text" class="search_td" v-model="searchForm.branch" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">発注者電話番号</div>
              <input type="text" class="search_td" v-model="searchForm.userTel" maxlength="11"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">知ったメディア</div>
              <div class="search_td container flex-wrap">
                <div v-for="(status,index) in mediaList" :key="'md-' + index">
                  <input type="checkbox" :id="'media_' + index" @click="setMedia($event, status.id)"
                    v-model="searchForm.media" v-bind:value="status.id"/>
                  <label :for="'media_' + index">{{status.label}}</label>
                </div>
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">招待コード</div>
              <input type="text" class="search_td" v-model="searchForm.inviteCode" maxlength="32"/>
            </div>
          </div>
        </div>
        <div class="search_content2">
          <div class="search_th">事前現場調査情報</div>
          <div>
            <div class="container search_li2">
              <div class="search_th2">調査物件名</div>
              <input type="text" class="search_td" v-model="searchForm.researchDeliName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">立会人氏名</div>
              <input type="text" class="search_td" v-model="searchForm.researchName" maxlength="32"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">立会人電話番号</div>
              <input type="text" class="search_td" v-model="searchForm.researchTel" maxlength="11"/>
            </div>
            <div class="container search_li2">
              <div class="search_th2">確定事前調査日</div>
              <div class="search_td">
                <dd-calendar
                  ref="researchDateStartRef"
                  :value="formatDate(searchForm.researchDateStart)"
                  :clearBtn="true"
                  :name="'researchDateStart'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
                <div class="separator">～</div>
                <dd-calendar
                  ref="researchDateEndRef"
                  :value="formatDate(searchForm.researchDateEnd)"
                  :clearBtn="true"
                  :name="'researchDateEnd'"
                  @selectedDate="selectedDate"
                  @clearedDate="clearedDate"
                />
              </div>
            </div>
            <div class="container search_li2">
              <div class="search_th2">依頼者の当日の立ち合い</div>
              <div class="search_td container flex-wrap">
                <div>
                  <input type="radio" name="attned" id="day_attend_01" v-model="searchForm.isDayAttend" value="true" @click="onClickRadioButton($event, 'isDayAttend')">
                  <label for="day_attend_01">あり</label>
                </div>
                <div>
                  <input type="radio" name="attned" id="day_attend_02" v-model="searchForm.isDayAttend" value="false" @click="onClickRadioButton($event, 'isDayAttend')">
                  <label for="day_attend_02">なし</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="main_btn pos_left" @click="clear()">クリア</button>
        <button class="main_btn pos_right" @click="close()">閉じる</button>
        <button class="main_btn search_btn" @click="search()">検索</button>
      </div>
    </div>
  </div>
</template>
<script>
import Calendar from '../../components/common/Calendar'
import moment from 'moment'

export default {
  name: 'estimateModal',
  components: {
    'dd-calendar': Calendar
  },
  props: {
    onSearch: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    refSearchForm: Object
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      statusList: [
        {id: 1, label: '営業中'},
        {id: 5, label: '発注依頼'},
        {id: 7, label: '受注'},
        {id: 9, label: '受注確定'},
        {id: 20, label: '生産計画済'},
        {id: 50, label: '生産完了'},
        {id: 55, label: '納品完了'},
        {id: 60, label: '失注'},
        {id: 70, label: '対象外'},
        {id: 103, label: 'EC発注'},
        {id: 104, label: 'EC未入金'},
        {id: 121, label: '事前調査依頼'},
        {id: 122, label: '事前調査依頼キャンセル'},
        {id: 123, label: '事前調査結果反映'},
        {id: 124, label: '事前調査完了'}
      ],
      // mediaList: [
      //   {id: 0, label: '設計事務所'},
      //   {id: 1, label: 'デザイン事務所'},
      //   {id: 2, label: 'リフォーム会社'},
      //   {id: 3, label: 'インテリアコーディネーター'},
      //   {id: 4, label: '設計施工会社'},
      //   {id: 5, label: '工務店'},
      //   {id: 6, label: '建設会社'},
      //   {id: 7, label: 'ゼネコン'},
      //   {id: 8, label: '職人'},
      //   {id: 9, label: '施工店'},
      //   {id: 10, label: 'ハウスメーカー'},
      //   {id: 11, label: 'デベロッパー'},
      //   {id: 12, label: '不動産業'},
      //   {id: 13, label: '賃貸管理会社'},
      //   {id: 14, label: '商社'},
      //   {id: 15, label: '家具製作会社'},
      //   {id: 16, label: '大家業 施主(法人)'},
      //   {id: 17, label: '家具小売・卸売'},
      //   {id: 99, label: 'その他'}
      // ],
      mediaList: [
        {id: 0, label: '新聞・雑誌・ニュース'},
        {id: 1, label: '専門誌・業界紙'},
        {id: 2, label: '展示会'},
        {id: 3, label: 'セミナー'},
        {id: 4, label: 'DM'},
        {id: 5, label: 'SNS'},
        {id: 6, label: '知人からの紹介'},
        {id: 7, label: '所属企業からの招待'},
        {id: 99, label: 'その他'}
      ],
      paymentList: [
        {id: 3, label: '掛け払い'},
        {id: 1, label: 'クレジットカード決済'},
        {id: 2, label: '銀行振込'}
      ],
      searchForm: {
        odMgCode: '',
        orderCode: '',
        planId: '',
        status: [],
        status3: undefined,
        updateUserName: '',
        orderDateStart: '',
        orderDateEnd: '',
        corpName: '',
        userName: '',
        paymentDateLimitType: '',
        paymentDateLimitStart: '',
        paymentDateLimitEnd: '',
        paymentType: [],
        paymentDateType: '',
        paymentDateStart: '',
        paymentDateEnd: '',
        priceStart: '',
        priceEnd: '',
        priceTaxStart: '',
        priceTaxEnd: '',
        seriesName: '',
        productName: '',
        sizeWStart: '',
        sizeWEnd: '',
        sizeHStart: '',
        sizeHEnd: '',
        sizeDStart: '',
        sizeDEnd: '',
        sizeW2Start: '',
        sizeW2End: '',
        sizeH2Start: '',
        sizeH2End: '',
        sizeD2Start: '',
        sizeD2End: '',
        doorColor: '',
        cabineColor: '',
        counterColor: '',
        isConstruct: '',
        isCarry: '',
        makerName: '',
        businessName: '',
        deliveryName: '',
        receiverName: '',
        receiverTel: '',
        deliveryAddress: '',
        infoDeliveryDateStart: '',
        infoDeliveryDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        platformDateStart: '',
        platformDateEnd: '',
        userDateStart: '',
        userDateEnd: '',
        constructDateStart: '',
        constructDateEnd: '',
        productUnitCount: '',
        attendName: '',
        attendTel: '',
        constructAddress: '',
        isHomeType: '',
        isParking: '',
        branch: '',
        userTel: '',
        media: [],
        inviteCode: '',
        researchDeliName: '',
        researchName: '',
        researchTel: '',
        researchDateStart: '',
        researchDateEnd: '',
        isDayAttend: ''
      }
    }
  },
  watch: {
  },
  computed: {
    isSelectedPaymentDate: function () {
      if (this.searchForm.paymentDateType === 1) {
        return true
      }
      return false
    },
    existStatus: function (id) {
      return function (id) {
        if (!this.searchForm) return false
        if (!this.searchForm.status) return false
        return this.searchForm.status.indexOf(id) >= 0
      }
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    search: function () {
      this.modalShown = false
      let searchForm = {
        odMgCode: this.searchForm.odMgCode,
        orderCode: this.searchForm.orderCode,
        planId: this.searchForm.planId,
        status: this.searchForm.status,
        updateUserName: this.searchForm.updateUserName,
        orderDateStart: this.searchForm.orderDateStart ? moment(this.searchForm.orderDateStart).startOf('day') : undefined,
        orderDateEnd: this.searchForm.orderDateEnd ? moment(this.searchForm.orderDateEnd).endOf('day') : undefined,
        corpName: this.searchForm.corpName,
        userName: this.searchForm.userName,
        paymentDateLimitType: this.searchForm.paymentDateLimitType,
        paymentDateLimitStart: this.searchForm.paymentDateLimitStart ? Number(this.searchForm.paymentDateLimitStart) : undefined,
        paymentDateLimitEnd: this.searchForm.paymentDateLimitEnd ? Number(this.searchForm.paymentDateLimitEnd) : undefined,
        paymentType: this.searchForm.paymentType,
        paymentDateType: this.searchForm.paymentDateType ? Number(this.searchForm.paymentDateType) : undefined,
        paymentDateStart: this.searchForm.paymentDateStart ? moment(this.searchForm.paymentDateStart).startOf('day') : undefined,
        paymentDateEnd: this.searchForm.paymentDateEnd ? moment(this.searchForm.paymentDateEnd).endOf('day') : undefined,
        priceStart: this.searchForm.priceStart,
        priceEnd: this.searchForm.priceEnd,
        priceTaxStart: this.searchForm.priceTaxStart,
        priceTaxEnd: this.searchForm.priceTaxEnd,
        seriesName: this.searchForm.seriesName,
        productName: this.searchForm.productName,
        sizeWStart: this.searchForm.sizeWStart,
        sizeWEnd: this.searchForm.sizeWEnd,
        sizeHStart: this.searchForm.sizeHStart,
        sizeHEnd: this.searchForm.sizeHEnd,
        sizeDStart: this.searchForm.sizeDStart,
        sizeDEnd: this.searchForm.sizeDEnd,
        sizeW2Start: this.searchForm.sizeW2Start,
        sizeW2End: this.searchForm.sizeW2End,
        sizeH2Start: this.searchForm.sizeH2Start,
        sizeH2End: this.searchForm.sizeH2End,
        sizeD2Start: this.searchForm.sizeD2Start,
        sizeD2End: this.searchForm.sizeD2End,
        doorColor: this.searchForm.doorColor,
        cabineColor: this.searchForm.cabineColor,
        counterColor: this.searchForm.counterColor,
        isConstruct: this.searchForm.isConstruct,
        isCarry: this.searchForm.isCarry,
        makerName: this.searchForm.makerName,
        businessName: this.searchForm.businessName,
        deliveryName: this.searchForm.deliveryName,
        receiverName: this.searchForm.receiverName,
        receiverTel: this.searchForm.receiverTel,
        deliveryAddress: this.searchForm.deliveryAddress,
        infoDeliveryDateStart: this.searchForm.infoDeliveryDateStart ? moment(this.searchForm.infoDeliveryDateStart).startOf('day') : undefined,
        infoDeliveryDateEnd: this.searchForm.infoDeliveryDateEnd ? moment(this.searchForm.infoDeliveryDateEnd).endOf('day') : undefined,
        deliveryDateStart: this.searchForm.deliveryDateStart ? moment(this.searchForm.deliveryDateStart).startOf('day') : undefined,
        deliveryDateEnd: this.searchForm.deliveryDateEnd ? moment(this.searchForm.deliveryDateEnd).endOf('day') : undefined,
        platformDateStart: this.searchForm.platformDateStart,
        platformDateEnd: this.searchForm.platformDateEnd,
        userDateStart: this.searchForm.userDateStart,
        userDateEnd: this.searchForm.userDateEnd,
        constructDateStart: this.searchForm.constructDateStart ? moment(this.searchForm.constructDateStart).startOf('day') : undefined,
        constructDateEnd: this.searchForm.constructDateEnd ? moment(this.searchForm.constructDateEnd).endOf('day') : undefined,
        productUnitCount: this.searchForm.productUnitCount,
        attendName: this.searchForm.attendName,
        attendTel: this.searchForm.attendTel,
        constructAddress: this.searchForm.constructAddress,
        isHomeType: this.searchForm.isHomeType,
        isParking: this.searchForm.isParking,
        branch: this.searchForm.branch,
        userTel: this.searchForm.userTel,
        media: this.searchForm.media,
        inviteCode: this.searchForm.inviteCode,
        researchDeliName: this.searchForm.researchDeliName,
        researchName: this.searchForm.researchName,
        researchTel: this.searchForm.researchTel,
        researchDateStart: this.searchForm.researchDateStart ? moment(this.searchForm.researchDateStart).startOf('day') : undefined,
        researchDateEnd: this.searchForm.researchDateEnd ? moment(this.searchForm.researchDateEnd).startOf('day') : undefined,
        isDayAttend: this.searchForm.isDayAttend
      }
      this.callbackParams.searchForm = searchForm
      this.onSearch(this.callbackParams)
    },
    clear: function () {
      this.searchForm = {
        odMgCode: '',
        orderCode: '',
        planId: '',
        status: [],
        updateUserName: '',
        orderDateStart: '',
        orderDateEnd: '',
        corpName: '',
        userName: '',
        paymentDateLimitType: '',
        paymentDateLimitStart: '',
        paymentDateLimitEnd: '',
        paymentType: [],
        paymentDateType: '',
        paymentDateStart: '',
        paymentDateEnd: '',
        priceStart: '',
        priceEnd: '',
        priceTaxStart: '',
        priceTaxEnd: '',
        seriesName: '',
        productName: '',
        sizeWStart: '',
        sizeWEnd: '',
        sizeHStart: '',
        sizeHEnd: '',
        sizeDStart: '',
        sizeDEnd: '',
        sizeW2Start: '',
        sizeW2End: '',
        sizeH2Start: '',
        sizeH2End: '',
        sizeD2Start: '',
        sizeD2End: '',
        doorColor: '',
        cabineColor: '',
        counterColor: '',
        isConstruct: '',
        isCarry: '',
        makerName: '',
        businessName: '',
        deliveryName: '',
        receiverName: '',
        receiverTel: '',
        deliveryAddress: '',
        infoDeliveryDateStart: '',
        infoDeliveryDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        platformDateStart: '',
        platformDateEnd: '',
        userDateStart: '',
        userDateEnd: '',
        constructDateStart: '',
        constructDateEnd: '',
        productUnitCount: '',
        attendName: '',
        attendTel: '',
        constructAddress: '',
        isHomeType: '',
        isParking: '',
        branch: '',
        userTel: '',
        media: [],
        inviteCode: '',
        researchDeliName: '',
        researchName: '',
        researchTel: '',
        researchDateStart: '',
        researchDateEnd: '',
        isDayAttend: ''
      }
      this.$refs.orderDateStartRef.cleared()
      this.$refs.orderDateEndRef.cleared()
      this.$refs.paymentDateStartRef.cleared()
      this.$refs.paymentDateEndRef.cleared()
      this.$refs.paymentDateLimitStartRef.cleared()
      this.$refs.paymentDateLimitEndRef.cleared()
      this.$refs.infoDeliveryDateStartRef.cleared()
      this.$refs.infoDeliveryDateEndRef.cleared()
      this.$refs.deliveryDateStartRef.cleared()
      this.$refs.deliveryDateEndRef.cleared()
      this.$refs.platformDateStartRef.cleared()
      this.$refs.platformDateEndRef.cleared()
      this.$refs.userDateStartRef.cleared()
      this.$refs.userDateEndRef.cleared()
      this.$refs.constructDateStartRef.cleared()
      this.$refs.constructDateEndRef.cleared()
      this.$refs.researchDateStartRef.cleared()
      this.$refs.researchDateEndRef.cleared()
    },
    setStatus: function (event, id) {
      if (event.target.checked === true) {
        this.searchForm.status.push(id)
      } else {
        this.searchForm.status = this.searchForm.status.filter(s => s !== id)
      }
    },
    setMedia: function (event, id) {
      if (event.target.checked === true) {
        this.searchForm.media.push(id)
      } else {
        this.searchForm.media = this.searchForm.media.filter(s => s !== id)
      }
    },
    setPaymentType: function (event, id) {
      if (event.target.checked === true) {
        this.searchForm.paymentType.push(id)
      } else {
        this.searchForm.paymentType = this.searchForm.paymentType.filter(s => s !== id)
      }
    },
    onClickPaymentDate: function (event) {
      if (this.searchForm.paymentDateType === Number(event.target.value)) {
        this.searchForm.paymentDateType = 0
      }
    },
    onClickRadioButton: function (event, name) {
      let val = Number(event.target.value)
      let obj = this.searchForm[name]
      if (obj !== val) {
        this.$set(this.searchForm, name, val)
      } else {
        this.$set(this.searchForm, name, '')
      }
    },
    selectedDate: function (name, date) {
      this.$set(this.searchForm, name, date)
    },
    clearedDate: function (name, date) {
      this.$set(this.searchForm, name, '')
    },
    formatDate: function (date) {
      if (!date) return ''
      let strDate = moment(date).format('YYYY-MM-DD')
      return strDate
    }
  },
  mounted: function () {
  },
  created: function () {
    this.searchForm = Object.assign({}, this.refSearchForm)
    if (this.searchForm.status) {
      this.searchForm.status = this.refSearchForm.status.slice()
    }
    if (this.searchForm.media) {
      this.searchForm.media = this.refSearchForm.media.slice()
    }
    if (this.searchForm.paymentType) {
      this.searchForm.paymentType = this.refSearchForm.paymentType.slice()
    }
  }
}
</script>
<style src="../../css/order/order_search.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/components/order/OrderSearchModal.vue